import { isNotNullOrUndefined, type Nullable } from '@vy/utils';
import { useState } from 'react';

type UseMenu = {
  anchorElement: Nullable<HTMLElement>;
  isOpen: boolean;
  handleMenuOpen: (event: React.MouseEvent<HTMLElement>) => void;
  handleMenuClose: () => void;
};

export function useMenu() {
  const [anchorElement, setAnchorElement] = useState<Nullable<HTMLElement>>(null);
  const isOpen = isNotNullOrUndefined(anchorElement);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElement(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorElement(null);
  };

  return buildUseMenuResponse(anchorElement, isOpen, handleMenuOpen, handleMenuClose);
}

function buildUseMenuResponse(
  anchorElement: Nullable<HTMLElement>,
  isOpen: boolean,
  handleMenuOpen: (event: React.MouseEvent<HTMLElement>) => void,
  handleMenuClose: () => void,
): UseMenu {
  return {
    anchorElement,
    isOpen,
    handleMenuOpen,
    handleMenuClose,
  };
}
